import { ViteSSG } from 'vite-ssg'
import App from './App.vue'
import { routes } from './router'
import { BASE_URL, GTM_ID } from './config'
import { createGtm } from '@gtm-support/vue-gtm';
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faPlus, faBars, faMagnifyingGlass, faTimes } from '@fortawesome/free-solid-svg-icons'

library.add(faPlus)
library.add(faBars)
library.add(faMagnifyingGlass)
library.add(faTimes)

import './sass/main.scss'

// ViteSSG export
export const createApp = ViteSSG(
  App,
  { routes, base: import.meta.env.BASE_URL },
  async ({ app, router, isClient }) => {

    app.component('font-awesome-icon', FontAwesomeIcon)

    // Load Highcharts only on client to avoid "self is not defined" in SSG
    if (isClient) {
      const Highcharts = await import('highcharts');
      const HighchartsVue = await import('highcharts-vue');

      // Modules
      await import('highcharts/modules/accessibility.js');
      await import('highcharts/highcharts-more');

      // Initial setup
      Highcharts.default.setOptions({
        lang: {
          decimalPoint: '.',
          thousandsSep: ','
        }
      });

      app.use(HighchartsVue.default, { tagName: "charts" })
    }

    // Analytics and document title update on route change
    router.afterEach(async (to) => {
      if (isClient) {
        // Basic title update if meta title is present, otherwise handled by component
        if (to.meta.title) {
          document.title = (to.meta.title as string) || '';

          window.dataLayer?.push?.({
            event: 'virtualPageview',
            pageUrl: BASE_URL + to.path,
            pageTitle: document.title
          });
        }
      }
    });

    if (isClient) {
      app.use(
        createGtm({
          id: GTM_ID,
          enabled: true,
          debug: true,
          vueRouter: router,
          loadScript: true,
          compatibility: false
        })
      )
    }
  }
)
